export function generateCookieName(name: string) {
  return process.env.REACT_APP_COOKIE_PREFIX
    ? `${process.env.REACT_APP_COOKIE_PREFIX}-${name}`
    : name;
}

export const ACCESS_TOKEN_COOKIE_NAME = generateCookieName("access-token");
export const REFRESH_TOKEN_COOKIE_NAME = generateCookieName("refresh-token");
